import React from 'react';

import ReactDOM from 'react-dom';
import _ from 'lodash';
import rawMarkup from '../../util/rawMarkup';



export default class EmbedIframe extends React.PureComponent {

  componentDidMount() {
  
    
    document.getElementById(`${this.props.article.id}`).contentWindow.postMessage("x-viafree-embed-pause",
    			'https://embed.viaplay.com/sport/'+ `${this.props.article.slug}` +'?partnerId=627ae684-701a-418f-98a2-8bc11690a1d7&postplay=click&autoplay=' + `${this.props.autoplay_freetexts}`);
    			
	  window.onload = function() {
	  let frameElement = document.getElementById('iframesport');
	  let doc = frameElement.contentDocument;
	  doc.body.innerHTML = doc.body.innerHTML + '<style>.category-title {display:none!important;}</style>';
	  
	 
	  }
   		$(".category-title").hide(); 
   		document.getElementById('iframesport').onload = function() {
   		let frameElement = document.getElementById('video-player');
	  let doc = frameElement.contentDocument;
	  doc.body.innerHTML = doc.body.innerHTML + '<style>.category-title {display:none!important;}</style>';
   			
   		}
  
	}
  


  componentWillUnmount() {
  }

  
  render() {
    const { iframe, article, autoplay} = this.props;
        return (
        <div>
		
	<div className="resp-container">
			<iframe
					//id={`${article.id}`}
					id={`iframesport`}
	                className="resp-iframe"
	                //src={`https://www.viafree.dk/embed/sport/id/${article.id}?autoplay=this.props.autoplay`}
	                src={iframe}
	                allowFullScreen
	                
	        >
	        </iframe>
      </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/component/ArticleFeed/EmbedIframe.jsx